<title class="greeting_info_a11y_page_header" tabindex="-1">
  {{confirmsContent?.seoBrowserTitle || 'Access Denied - Confirmations'}}
</title>
<ss-lib-page-layout>
  <div inner>
    <div class="row">
      <div class="col">
        <gyd-secondary-nav-widget active-item="ActivityTab"></gyd-secondary-nav-widget>
        <div class='row'>
          <div class='col-12 col-md-9'>
            <app-tetriary-navigation [options]="tetriaryNavigationOptions" activeLink="CONFIRMATIONS">
            </app-tetriary-navigation>
          </div>
          <div class="col-12 col-md-3 justify-content-md-end d-flex" data-testid="tertiary-nav">
            <div class="tertiary-nav__customize_account">
              <a c11n-link [attr.href]="downloadLinkUrl" data-testid="download-center-link"
                 variant="secondary-independent"
                 [attr.aria-label]="'Download center account information'">
                <span class="c11n-link__text">{{ downloadLinkLabel }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="transaction-summary">
          <div id="transaction-history-summary-section">
            <div class="main-div">
              <div class="container-fluid p-0">
                <ng-container *ngIf="shouldShowErrorBanner">
                  <div class="row">
                    <div class="col">
                      <c11n-banner [size]="errorBannerConfig.size" [headingText]="errorBannerConfig.heading"
                                   [hasCloseControl]="errorBannerConfig.closable"
                                   [variant]="errorBannerConfig.variant">
                        <div class="c11n-text-md--crop">{{ errorBannerConfig.body }}</div>
                      </c11n-banner>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="environment.internal">
                  <div class="row pt-3">
                    <div class="col">
                      <c11n-internal-callout variant="horizontal" [headingLevel]="2">
                        <p class="c11n-text-md-bold">This page is for crew only. Clients cannot view this page.</p>
                      </c11n-internal-callout>
                    </div>
                  </div>
                </ng-container>
                <div class="header-div mt-3">
                  <div class="row">
                    <div class="col-12 col-md-7 col-lg-8 c11n-grid-story__cell">
                      <h1 class='sub-heading'>{{ confirmsContent?.heading }}</h1>
                      <div class='row mt-2 desktop-description-view'>
                        <span class='confirmations-are-av' [innerHTML]='confirmsContent?.confirmsDescription'></span>
                      </div>
                    </div>
                    <div class="col-12 col-md-5 col-lg-4 c11n-grid-story__cell view-select-wrapper mt-3 mt-md-0">
                      <div class="col-8 float-right-class">
                        <div [ngStyle]="{'maxWidth': '14rem', 'width': '100%', 'text-align': 'left'}"
                             class="view-select-div float-right-class">
                          <c11n-dropdown [menuData]="dropdownMenuOptions" [labelText]="confirmsContent?.viewDropdownLabel || 'View'"
                                         (stateChange)="viewRedirect($event)"
                                         [placeholderText]="confirmsContent?.viewDropdownPlaceholder || 'Select view'"
                                         variant="basic"
                                         class="selectViewDropdown" aria-label="select view"></c11n-dropdown>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="container_error mt-5">
                  <div class="icon_error">
                    <svg viewBox="0 0 8 14" fill="#ba3d21" focusable="false" aria-hidden="true">
                      <use xlink:href="#error-small"></use>
                    </svg>
                  </div>
                  <p></p>
                  @switch (reason) {
                    @case ('poid-missing') {
                      <h1 class="h1_error mt-4">{{content.poidNotPresentError.heading}}</h1>
                      <div class="c11n-text-md mt-3 mb-4">
                        <p class="mb-2" [innerHTML]="content.poidNotPresentError.body"></p>
                      </div>
                    }
                    @default {
                      <h1 class="h1_error mt-4">{{content.accessDeniedError.heading}}</h1>
                      <div class="c11n-text-md mt-3 mb-4">
                        <p class="mb-2" [innerHTML]="content.accessDeniedError.body"></p>
                        <p class="mb-2" [innerHTML]="content.accessDeniedError.sailpointRequest"></p>
                        <p class="mb-0" [innerHTML]="content.sailpointAccessError"></p>
                      </div>
                    }
                  }
                </div>

                <div class="disclaimer mb-4" [innerHTML]="confirmsContent?.disclaimer || ''"></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ss-lib-page-layout>
